import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import WorksheetGrid from 'components/worksheet/worksheet_grid';
import withRouteParams from 'utils/with_route_params';

@observer
class WorksheetIndex extends React.Component {

  render() {
    return (
      <WorksheetGrid
        useGridLayout
        showFilters
        {...this.props}
      />
    );
  }
}

export default withRouteParams(ErrorBoundary(WorksheetIndex));
